module.exports = __webpack_public_path__ + "static/media/office4.a41e396e.jpg";